module.exports = __webpack_public_path__ + "static/wegather-3c91dce938c90f0d641c4bd8e78f24a4.svg";